<script setup>
import { computed } from 'vue'

const props = defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'testimonials-01' },
})

const validItems = computed(() =>
  (props.content.items.value || []).filter(t => t.name && t.location && t.quote)
)
</script>

<template>
  <section v-if="validItems.length" class="b2-testimonials" :class="`variant-${variant}`">
    <div class="b2-section-intro b2-centered">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
    </div>
    <div class="b2-testimonials-grid">
      <div v-for="t in validItems" :key="t.name" class="b2-testimonial-card">
        <div class="b2-stars">★★★★★</div>
        <p class="b2-testimonial-quote">"{{ t.quote }}"</p>
        <div class="b2-testimonial-author">
          <div class="b2-author-avatar">{{ t.name[0] }}</div>
          <div>
            <strong>{{ t.name }}</strong>
            <span>{{ t.location }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.b2-testimonials { background: #1a3320; color: white; padding: 100px 40px; text-align: center; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #8fcf7e; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: white; line-height: 1.15; margin-bottom: 16px; }
.b2-section-intro.b2-centered { text-align: center; }
.b2-testimonials-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 24px; max-width: 1100px; margin: 48px auto 0; text-align: left; }
.b2-testimonial-card { background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.1); border-radius: 4px; padding: 28px; }
.b2-stars { color: #8fcf7e; font-size: 16px; margin-bottom: 14px; letter-spacing: 3px; }
.b2-testimonial-quote { font-size: 15px; line-height: 1.7; color: rgba(255,255,255,.85); margin-bottom: 22px; font-style: italic; }
.b2-testimonial-author { display: flex; align-items: center; gap: 12px; }
.b2-author-avatar { width: 40px; height: 40px; border-radius: 50%; background: #4a8c3f; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 15px; color: white; flex-shrink: 0; }
.b2-testimonial-author strong { display: block; font-size: 14px; color: white; }
.b2-testimonial-author span { font-size: 13px; color: rgba(255,255,255,.5); }
.variant-testimonials-02 { background: #f5f9f4; color: #1a3320; }
.variant-testimonials-02 .b2-section-label { color: #4a8c3f; }
.variant-testimonials-02 .b2-section-title, .variant-testimonials-02 .b2-testimonial-author strong { color: #1a3320; }
.variant-testimonials-02 .b2-testimonial-card { background: white; border-color: #dce7da; box-shadow: 0 10px 35px rgba(26,51,32,.08); }
.variant-testimonials-02 .b2-testimonial-quote { color: #4d5b50; }
.variant-testimonials-02 .b2-testimonial-author span { color: #78827a; }
.variant-testimonials-03 { background: white; color: #1a3320; }
.variant-testimonials-03 .b2-section-label { color: #4a8c3f; }
.variant-testimonials-03 .b2-section-title { color: #1a3320; }
.variant-testimonials-03 .b2-testimonials-grid { display: block; max-width: 780px; text-align: center; }
.variant-testimonials-03 .b2-testimonial-card { background: transparent; border: 0; border-bottom: 1px solid #dce7da; border-radius: 0; padding: 34px 0; }
.variant-testimonials-03 .b2-testimonial-quote { color: #344438; font-family: 'Playfair Display', serif; font-size: 22px; }
.variant-testimonials-03 .b2-testimonial-author { justify-content: center; }
.variant-testimonials-03 .b2-testimonial-author strong { color: #1a3320; }
.variant-testimonials-03 .b2-testimonial-author span { color: #78827a; }
</style>
